const API_BASE = (import.meta as any).env?.VITE_API_BASE ?? 'https://app-xyqar-api.azurewebsites.net';
export { API_BASE };
export async function apiGet<T = any>(path: string, token?: string): Promise<T> {
  const r = await fetch(`${API_BASE}${path}`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
  if (!r.ok) {
    const text = await r.text();
    let detail = '';
    try {
      detail = JSON.parse(text)?.detail ?? '';
    } catch {
      detail = text;
    }
    throw new Error(detail || `HTTP ${r.status}`);
  }
  return r.json();
}
export async function apiPost<T = any>(path: string, body: any, token?: string): Promise<T> {
  const r = await fetch(`${API_BASE}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify(body),
  });
  if (!r.ok) {
    const text = await r.text();
    let detail = '';
    try {
      detail = JSON.parse(text)?.detail ?? '';
    } catch {
      detail = text;
    }
    throw new Error(detail || `HTTP ${r.status}`);
  }
  return r.json();
}
